import createReducer from 'lib/createReducer';

export const RESET_READER = 'RESET_READER';
export const SAVE_BOOK_PAGE_BREAK = 'SAVE_BOOK_PAGE_BREAK';
export const SAVE_EBOOK = 'SAVE_EBOOK';
export const SAVE_SCROLL_CFI = 'SAVE_SCROLL_CFI';
export const SAVE_URL_PARAMS = 'SAVE_URL_PARAMS';
export const SAVE_IS_MOBILE = 'SAVE_IS_MOBILE';
export const HIDE_PAGE_SELECTOR = 'HIDE_PAGE_SELECTOR';
export const SHOW_PAGE_SELECTOR = 'SHOW_PAGE_SELECTOR';
export const SAVE_CONFIGURATION = 'SAVE_CONFIGURATION';


const initialState = {
  currentCfi: '',
  currentPageBreak: '',
  ebook: {
    rc: null,
    cfi: '',
    vbid: '',
    start: '',
    stop: ''
  },
  configuration: {},
  fromSnippetExit: false,
  isMobile: false,
  isSnippet: false,
  redirectOrigin: '',
  showPageSelector: false
};

const reader = createReducer(initialState, {
  [RESET_READER]: (state, action) => {
    const { ebook } = state;
    const reset = {
      currentCfi: '',
      currentPageBreak: '',
      isSnippet: false,
      ebook: {
        rc: null,
        ro: ebook.ro,
        vbid: ebook.vbid
      },
      configuration: {},
      fromSnippetExit: true
    };

    return { ...state, ...reset };
  },

  [SAVE_BOOK_PAGE_BREAK]: (state, action) => {
    return { ...state, currentPageBreak: action.data };
  },

  [SAVE_EBOOK]: (state, action) => {
    return { ...state, ebook: action.data, fromSnippetExit: false };
  },

  [SAVE_SCROLL_CFI]: (state, action) => {
    return { ...state, currentCfi: action.data.cfi };
  },

  [SAVE_URL_PARAMS]: (state, action) => {
    const { isMobile, data } = action.data;
    const isSnippet = !!data.start;

    return { ...state, ebook: data, isMobile, isSnippet };
  },

  [SAVE_CONFIGURATION]: (state, action) => {
    return { ...state, configuration: action.data };
  },

  [SAVE_IS_MOBILE]: (state, action) => {
    return { ...state, isMobile: !state.isMobile };
  },

  [HIDE_PAGE_SELECTOR]: (state, action) => {
    return { ...state, showPageSelector: false };
  },

  [SHOW_PAGE_SELECTOR]: (state, action) => {
    return { ...state, showPageSelector: true };
  }
});


export default reader;
